import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../../services/registration.service';
import { RegistrationFirstStepModel, RegistrationCompleteModel } from '../../models/registration/registration.models';
import { AuthService } from '../../auth/auth.service';
import { RouterService } from '../../services/routerService';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Configuration } from '../../configuration';

@Component({
    selector: 'supplier-registration',
    template: require('./supplier.registration.component.html'),
    styles: [require('./supplier.registration.component.css')]
})
export class SupplierRegistrationComponent implements OnInit {
    firstStepModel: RegistrationFirstStepModel;
    firstStepToken: string;

    routeParamsSub: Subscription;

    furtherInfoModel: RegistrationCompleteModel;
    @BlockUI('details-block') private detailsBlock: NgBlockUI;
    @BlockUI('reg-block') private regBlock: NgBlockUI;

    constructor(private readonly config: Configuration,
        private readonly registrationService: RegistrationService,
        private readonly routerService: RouterService,
        private readonly authService: AuthService,
        private userService: LoggedInUserService,
        private readonly route: ActivatedRoute) {

        this.routerService.doNotAddCurrentPageToRouteStack();
        this.firstStepModel = new RegistrationFirstStepModel();
        this.furtherInfoModel = new RegistrationCompleteModel();
    }

    ngOnInit() {
        if (this.userService.getCurrentUser()) {
            this.routerService.router.navigateByUrl('/tenders/mymatches');
        }

        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            this.firstStepModel.referrerId = params['refId'];
            this.firstStepModel.catId = params['catId'];
            this.firstStepModel.locId = params['locId'];
            this.firstStepModel.gclid = params['gcl'] || this.getGclidFromCookie();

            this.registrationService.getRegistrationPageText(this.firstStepModel).subscribe((response: any) => {
                this.firstStepModel.registrationPageText = response.regText;
            });

            this.registrationService.getRegistrationPageFooterText(this.firstStepModel).subscribe((response: any) => {
                this.furtherInfoModel.registrationPageFooterText = response.regText;
            });
        });
    }

    private getGclidFromCookie(): string {
        const match = document.cookie.match(/(?:^|;\s*)_gcl_aw=([^;]*)/);
        if (!match) return undefined;
        const value = decodeURIComponent(match[1]);
        const gclid = value.substring(value.lastIndexOf('.') + 1);
        return gclid || undefined;
    }

    submitFirstStep() {
        this.detailsBlock.start();
        this.registrationService.firstStepComplete(this.firstStepModel).subscribe((response: any) => {
            this.detailsBlock.stop();
            this.furtherInfoModel.registrationToken = response.value;
            this.furtherInfoModel.tAndCsAgreed = this.firstStepModel.tAndCsAgreed;
        }, () => { this.detailsBlock.stop(); });
    }

    submitFurtherInfo() {
        this.regBlock.start();
        this.registrationService.registrationComplete(this.furtherInfoModel).subscribe(() => {
            this.authService.login(this.firstStepModel.emailAddress, this.firstStepModel.password).subscribe(() => {
                this.regBlock.stop();
                this.routerService.router.navigateByUrl(`registration/thankyou`);
            }, () => { this.regBlock.stop(); });
        }, () => { this.regBlock.stop(); });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/registration/supplier.registration.component.ts